<template>
    <div class="container" id="contracts" role="tabpanel" aria-labelledby="contracts-tab">
        <div class="card">
            <div class="card-header">
                Contratos

                <md-button
                    @click="_sendContracts()"
                    class="md-primary md-raised float-right"
                    v-if="project.status > 5 && project.signing_type == 2"
                    :disabled="project.contracts.length == 0 || (project.status >= 4 && !is_admin)">
                    Enviar por Mifiel
                </md-button>
                <md-button
                    @click="_sendContracts()"
                    class="md-primary md-raised float-right"
                    v-if="project.status > 5 && project.signing_type == 1"
                    :disabled="project.contracts.length == 0 || (project.status >= 4 && !is_admin)">
                    Enviar por correo
                </md-button>
                <md-button
                        class="md-accent float-right"
                        :disabled="(project.status >= 4 && !is_admin)"
                        v-if="project.status > 5"
                        @click="_generate_contracts()">
                        Generar contratos
                </md-button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <md-field>
                            <label>Deseo de firma </label>
                            <md-input disabled class="form-control" :value="signTypeWish" />
                        </md-field>
                        <md-field>
                            <label>Instrumento Legal</label>
                            <md-select
                                    :disabled="(project.status >= 4 && !is_admin)"
                                    v-model="project.finance.finance_type">
                                <md-option value="0">Crédito solar</md-option>
                                <md-option value="1">Arrendamiento</md-option>
                                <md-option value="2">Préstamo simple</md-option>
                            </md-select>
                        </md-field>
                        <md-field>
                            <label>Metodo de firma</label>
                            <md-select v-model="project.signing_type">
                                <md-option value="2">Electrónica</md-option>
                                <md-option value="1">Autógrafa</md-option>
                            </md-select>
                        </md-field>
                        <md-field>
                            <label>Fecha de primer pago</label>
                            <md-input type="date" :disabled="(project.status >= 4 && !is_admin)"  class="form-control" v-model="project.finance.first_payment_date" />
                        </md-field>

                        <button class="btn btn-primary btn-raised"
                            :disabled="project.status > 6"
                            @click="updateContractData()">
                            Modificar
                        </button>
                    </div>

                    <div v-if="project.signing_type_wish == 1 && project.delivery_service_type != null" class="col-md-4">
                        <vx-card title="Información de envío">
                            <p class="black">Servicio de mensajería: <span class="bold orange">{{setDeliveryService(project.delivery_service_type)}}</span></p>
                            <p class="black" v-if="project.delivery_service_other != null">Otro servicio de mensajería: <span class="bold">{{project.delivery_service_other}}</span></p>
                            <p class="black">Número de guía: <span class="bold">{{project.delivery_tracking_id}}</span></p>
                        </vx-card>
                    </div>
                </div>

                <div class="table-container">
                    <table class="table table-hover table-sm">
                        <thead class="thead-dark">
                            <th>Nombre</th>
                            <th>Version</th>
                            <th>Fecha de creación</th>
                            <th>Fecha de recepción</th>
                            <th width="80px">Estatus</th>
                            <th>Firmantes</th>
                            <th>Opciones</th>
                        </thead>
                        <tbody v-if="project.contracts.length > 0">
                            <tr v-for="contract in project.contracts" v-bind:key="contract.id">
                                <td>{{contract.type.name}}</td>
                                <td>{{contract.type.version}}</td>
                                <td>{{contract.created_at | humanDate}}</td>
                                <td>{{contract.file_upload_date | humanDate}}</td>
                                <td>
                                    <span class="label"
                                        v-bind:class="{
                                            'label-status-1': (contract.status == 'signed'),
                                            'label-status-10': (contract.status == 'generated' || contract.status == 'sent'),
                                            'label-status-9': (contract.status == 'canceled')}">
                                        {{contract.status}}</span>
                                </td>
                                <td>
                                    <span v-for="signatory in contract.signatories_json">
                                        <a-secure :href="'mailto:' + signatory.email"> {{signatory.email}} </a-secure>
                                    </span>
                                </td>
                                <td>
                                    <a-secure class="btn btn-default btn-raised btn-sm"
                                        :href="`${StorageURL}/storage/private/contracts/${contract.id}/${contract.contract_not_signed_file}?access_token=${user.access_token}`"
                                        target="_blank" rel="noopener">NO FIRMADOS</a-secure>
                                    <a-secure class="btn btn-default btn-raised btn-sm"
                                        v-if="contract.contract_signed_file !== null"
                                        :href="`${StorageURL}/storage/private/contracts-signed/${contract.id}/${contract.contract_signed_file}?access_token=${user.access_token}`" target="_blank" rel="noopener">
                                        FIRMADOS</a-secure>
                                    <a-secure class="btn btn-default btn-raised btn-sm"
                                        v-if="contract.contract_signed_xml_file !== null"
                                        :href="`${StorageURL}/storage/private/contracts-signed/${contract.id}/${contract.contract_signed_xml_file}?access_token=${user.access_token}`" target="_blank" rel="noopener">
                                        XML FIRMADOS
                                    </a-secure>
                                    <button v-if="project.signing_type == 1 && contract.status !== 'canceled'"
                                        class="btn btn-secondary btn-sm btn-raised"
                                        @click="upladContractModal(contract)">
                                        <em class="fas fa-file-upload"></em>
                                    </button>
                                    <button v-if="project.signing_type == 2 && contract.status !== 'canceled'"
                                        class="btn btn-default btn-raised btn-sm"
                                        @click="uploadElectronicContractModal(contract)">
                                        <em class="fas fa-file-upload"></em>
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="modal fade" tabindex="-1" role="dialog" id="modal_upload_contracts">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Subir contrato ({{currentContract.type.name}})</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="form-group">
                        <label>Cliente</label>
                        <input type="text" disabled :value="project.fiscal_name" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Contrato</label>
                        <input type="file" class="form-control" ref="file">
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-primary" @click="send()">Guardar</button>
                </div>
                </div>
            </div>
        </div>

        <div class="modal fade" tabindex="-1" role="dialog" id="modal_upload_electronic_contracts">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Subir Contrato Electrónico ({{currentContract.type.name}})</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="form-group">
                        <label>Cliente</label>
                        <input type="text" disabled :value="project.fiscal_name" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>PDF</label>
                        <input type="file" class="form-control" ref="file_pdf">
                    </div>
                    <div class="form-group">
                        <label>XML</label>
                        <input type="file" class="form-control" ref="file_xml">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-primary" @click="uploadElectronicFile()">Guardar</button>
                </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { is } from '../../functions/userRoleBehavior'
import { AxiosErrorException } from '../../functions/axiosErrorException';
import { humanDateFilter } from "../../../../components/admin/filters/humanDateFilter";
import { mapState, mapActions } from 'vuex'
import {ContractProvider} from "../../../../bl/enums/ContractProvider";
import ASecure from "@components/utils/aSecure";

export default {
  components: {ASecure},
  filters: {
        'humanDate': humanDateFilter
    },
    data() {
        return {
            contracts: [],
            currentContract: { type: {name: ""}},
            old_first_payment_date: null,
            contract_id: null
        }
    },
    computed: {
        ...mapState('projects', ['project']),
        ...mapState('auth', ['user']),
        is_admin() {
            return is('admin', this.user.user_roles)
        },
        signTypeWish(){
            if(this.project.signing_type_wish == 1){
                return "Firma autógrafa (proceso manual)"
            }
            else if(this.project.signing_type_wish == 2) {
                return "Firma electrónica a través de MIFIEL con la efirma";
            }
            else {
                return "No definido";
            }
        }
    },
    mounted() {
        this.old_first_payment_date = Object.assign({}, this.project.finance.first_payment_date)
    },
    methods: {
        ...mapActions('projects', ['generateContracts', 'sendContracts']),
        updateContractData() {
            if(this.old_first_payment_date !== this.project.finance.first_payment_date) {
                if(confirm("Al editar la fecha de primer pago, se regenerará la tabla de amortización. ¿Desea continuar?")) {
                    this.__updateContractData()
                }
            } else {
                this.__updateContractData()
            }
        },
        async __updateContractData() {
            try {
                await axios.put(`/api/project/${this.project.id}`, { signing_type: this.project.signing_type })
                await axios.put(`/api/project/${this.project.id}/finance`, {
                    first_payment_date: this.project.finance.first_payment_date,
                    finance_type: this.project.finance.finance_type
                })
                swal("Ok", "La información se guardo correctamente!", "success")
            } catch (ex) {
                console.error(ex);
                swal("Ups!", "Hubo un error al guardar la información", "error")
            }
        },
        async uploadElectronicFile() {
            let FormDataRequestHandler = new FormData();
            let pdfFile = this.$refs.file_pdf.files[0];
            let xmlFile = this.$refs.file_xml.files[0];
            FormDataRequestHandler.append("pdf_contract", pdfFile);
            FormDataRequestHandler.append("xml_contract", xmlFile);
            FormDataRequestHandler.append("contract_id", this.currentContract.id);

            try {
                let res = await axios.post(`/api/project/${this.project.id}/contract/electronic`, FormDataRequestHandler, {
                    headers: { "Content-Type": "multipart/form-data" }
                });

                swal("Ok!", "El contrato se subio correctamente", "success");
                this.contracts.status = res.data.status;
                this.contracts.file_upload_date = res.data.file_upload_date;

                $("#modal_upload_electronic_contracts").modal("hide")
            } catch (err) {
                swal("Ups!", AxiosErrorException(err), "error");
            }
        },
        send() {
            let contract = new FormData();
            let file = this.$refs.file.files[0];
            contract.append("contract", file);
            contract.append("project_id", this.project.id);
            contract.append("client_id", this.project.client.id);
            contract.append("contract_id", this.currentContract.id);

            axios.post("/api/project/"+ this.project.id + "/upload_contract", contract, {
                headers: { "Content-Type": "multipart/form-data" }
            })
            .then((res) => {
                swal("Ok!", "El contrato se subio correctamente", "success")
                this.currentContract.status = res.data.status
                this.currentContract.file_upload_date = res.data.file_upload_date
                $("#modal_upload_contracts").modal("hide");
            })
            .catch((err) => {
                swal("Ups!", AxiosErrorException(err), "error");
            })
        },
        async _sendContracts() {
            let messageConfirmation = (this.project.signing_type == ContractProvider.MIFIEL)
                ? "Esta seguro de enviar correos a firma por MiFiel?"
                : "Esta seguro de enviar correos a firma por email?";

            if(confirm(messageConfirmation)) {
                this.show = true;
                try {
                    await this.sendContracts({id: this.project.id, signing_type: this.project.signing_type})
                    swal("Ok!", "Los contratos se han enviado correctamente!", "success");
                } catch(err) {
                    console.error(err)
                    swal("Ups!", AxiosErrorException(err), "error")
                } finally {
                    this.show = false;
                }
            }
        },
        async _generate_contracts() {
            try {
                await this.generateContracts(this.project.id);
            } catch(e) {
                console.error(e);
                swal("Ups!", AxiosErrorException(e), "error")
            }
        },
        uploadElectronicContractModal(contract) {
            this.currentContract = contract
            $("#modal_upload_electronic_contracts").modal("show");
        },
        async upladContractModal(contract) {
            $("#modal_upload_contracts").modal("show");
            this.currentContract = contract
        },

        setDeliveryService(type){
            let name = "";
            switch(type){
                case 1:
                    name = "Mensajería propia"
                    break;
                case 2:
                    name = "Correos de México"
                    break;
                case 3:
                    name = "DHL"
                    break;
                case 4:
                    name = "Estafeta"
                    break;
                case 5:
                    name = "FedEx"
                    break;
                case 6:
                    name = "PaqueteExpress"
                    break;
                case 7:
                    name = "RedPack"
                    break;
                case 8:
                    name = "Sendex Paquetería"
                    break;
                case 9:
                    name = "UPS"
                    break;
                case 10:
                    name = "Otro servicio"
                    break;
                    default: name = "--"
            }
            return name;
        }
    }
}
</script>
<style scoped>
.table-container {
    min-height: 40vh;
}
.dropdown-toggle {
    background-color: #6c757d !important;
}

    .vx-card h4 {
        font-family: 'Poppins', sans-serif !important;
    }
</style>
